// src/components/Footer.jsx
import React from 'react';
import { Box, Container, Grid, Typography, Divider } from '@mui/material';
import { Phone, Room } from '@mui/icons-material';
import Avatar from '@mui/material/Avatar';
import { styled } from '@mui/system';
import logo from '../assets/img/logo.png';

/* === “Dark Tailwind” look (slate-900) + 3D accents === */
const DarkFooter = styled(Box)({
  position: 'relative',
  background: 'linear-gradient(180deg,#0f172a 0%, #0b1220 60%, #0a0f1c 100%)', // tailwind slate-900 vibe
  color: 'rgba(255,255,255,.92)',
  textAlign: 'center',
  paddingTop: '28px',
  paddingBottom: '28px',
  borderTop: '1px solid rgba(255,255,255,.06)',
  overflow: 'hidden',
  /* Glow dorado muy sutil arriba */
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0, left: 0, right: 0, height: 2,
    background:
      'linear-gradient(90deg, rgba(0,0,0,0) 0%, rgba(218,165,32,.9) 50%, rgba(0,0,0,0) 100%)',
    boxShadow: '0 0 18px rgba(218,165,32,.38)',
    pointerEvents: 'none',
  },
});

/* Icono con medallón 3D */
const Icon3D = styled('div')({
  width: 56,
  height: 56,
  marginBottom: 10,
  borderRadius: '50%',
  display: 'grid',
  placeItems: 'center',
  background:
    'linear-gradient(180deg, rgba(218,165,32,.22) 0%, rgba(218,165,32,.08) 100%)',
  border: '1px solid rgba(218,165,32,.45)',
  boxShadow:
    '0 10px 24px rgba(218,165,32,.25), inset 0 1px 0 rgba(255,255,255,.25)',
});

/* Títulos y textos */
const Label = styled(Typography)({
  fontWeight: 900,
  letterSpacing: '.06em',
  color: '#F5DEB3',
});
const Subtle = styled(Typography)({
  color: 'rgba(255,255,255,.75)',
});

const Brand = styled(Typography)({
  fontWeight: 900,
  letterSpacing: '.02em',
  fontSize: '1.6rem',
  marginLeft: 10,
  textShadow: '0 1px 0 rgba(0,0,0,.45)',
});

const Card = styled(Box)({
  borderRadius: 16,
  padding: '18px 14px',
  background: 'linear-gradient(180deg, rgba(255,255,255,.04) 0%, rgba(255,255,255,.02) 100%)',
  border: '1px solid rgba(255,255,255,.08)',
  boxShadow:
    '0 1px 0 rgba(255,255,255,.1) inset, 0 18px 36px rgba(0,0,0,.35), 0 60px 100px rgba(0,0,0,.25)',
  transition: 'transform .2s ease, box-shadow .25s ease, border-color .25s ease',
  backdropFilter: 'blur(6px)',
  '&:hover': {
    transform: 'translateY(-3px)',
    borderColor: 'rgba(218,165,32,.35)',
    boxShadow:
      '0 1px 0 rgba(255,255,255,.12) inset, 0 26px 50px rgba(0,0,0,.45), 0 90px 140px rgba(0,0,0,.3)',
  },
});

const Footer = () => {
  return (
    <DarkFooter>
      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="stretch">
          {/* Columna izquierda: datos */}
          <Grid item xs={12} md={6}>
            <Grid container spacing={2} mt="1.2rem" justifyContent="center">
              <Grid item xs={12} sm={5.5}>
                <Card>
                  <Box display="flex" flexDirection="column" alignItems="center">
                    <Icon3D>
                      <Room sx={{ fontSize: 28, color: '#EABE2a' }} />
                    </Icon3D>
                    <Label variant="subtitle2">UBICACIÓN</Label>
                    <Subtle className="custom-second" sx={{ mt: .5 }}>
                      BUENOS AIRES
                    </Subtle>
                  </Box>
                </Card>
              </Grid>

              <Grid item xs={12} sm={5.5}>
                <Card>
                  <Box display="flex" flexDirection="column" alignItems="center">
                    <Icon3D>
                      <Phone sx={{ fontSize: 28, color: '#EABE2a' }} />
                    </Icon3D>
                    <Label variant="subtitle2">CELULAR</Label>
                    <Subtle className="custom-second" sx={{ mt: .5 }}>
                      Comunicate al WhatsApp
                    </Subtle>
                  </Box>
                </Card>
              </Grid>
            </Grid>
          </Grid>

          {/* Columna derecha: marca + texto */}
          <Grid item xs={12} md={6}>
            <Box textAlign="center" height="100%" display="flex" flexDirection="column" justifyContent="center">
              <Box display="flex" justifyContent="center" alignItems="center" gap={1}>
                <Avatar
                  alt="Ferracort"
                  src={logo}
                  variant="rounded"
                  sx={{
                    width: 140,
                    height: 110,
                    borderRadius: 3,
                    boxShadow: '0 14px 28px rgba(0,0,0,.45)',
                    border: '1px solid rgba(255,255,255,.08)',
                    backgroundColor: 'rgba(255,255,255,.02)',
                  }}
                />
                <Brand className="custom-logo">FERRACORT</Brand>
              </Box>

              <Subtle className="custom-second" sx={{ mt: 2, mx: 'auto', maxWidth: 520 }}>
                “Con más de tres décadas de experiencia, somos líderes en la venta de persianas de aluminio
                de alta calidad, inyectadas con poliuretano y PVC. Ofrecemos soluciones duraderas y
                estilizadas para mejorar cualquier espacio.”
              </Subtle>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 3, borderColor: 'rgba(255,255,255,.06)' }} />

        <Subtle variant="body2">&copy; 2020 — Todos los derechos reservados</Subtle>
      </Container>
    </DarkFooter>
  );
};

export default Footer;
